<template>
  <div class="career">
    <h1>Career</h1>
    <p>Нажмите на карточку, чтобы увидеть подробности:</p>
    <div class="job-cards">
      <router-link 
        v-for="job in jobs" 
        :key="job.id"
        :to="`/career/${job.id}`" 
        class="job-card"
      >
        <div class="job-card-content">
          <h2>{{ job.title }}</h2>
          <p class="company">{{ job.company }}</p>
          <p class="duration">{{ job.duration }}</p>
          <div
            class="technologies"
            v-if="job.positions
              ? job.positions[0].technologies?.length
              : job.technologies?.length"
          >
            <template v-if="job.positions">
              <!-- For jobs with multiple positions, show technologies from the latest position -->
              <span
                v-for="tech in job.positions[0].technologies.slice(0, 3)"
                :key="tech"
                class="tech-tag"
              >
                {{ tech }}
              </span>
              <span
                v-if="job.positions[0].technologies.length > 3"
                class="tech-tag more"
              >
                +{{ job.positions[0].technologies.length - 3 }}
              </span>
            </template>
            <template v-else>
              <!-- For jobs with direct technologies -->
              <span
                v-for="tech in job.technologies.slice(0, 3)"
                :key="tech"
                class="tech-tag"
              >
                {{ tech }}
              </span>
              <span
                v-if="job.technologies.length > 3"
                class="tech-tag more"
              >
                +{{ job.technologies.length - 3 }}
              </span>
            </template>
          </div>
        </div>
        <div class="arrow">→</div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { jobs } from '../stores/jobs';

export default {
  name: 'CareerPage',
  data() {
    return {
      jobs
    };
  }
};
</script>

<style scoped>
.career {
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
}

.job-cards {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.job-card {
  background-color: #2d2d2d;
  padding: 1.5rem;
  border-radius: 8px;
  color: #d4d4d4;
  text-decoration: none;
  transition: all 0.3s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #333;
  position: relative;
}

.job-card:hover {
  background-color: #3d3d3d;
  transform: translateX(5px);
}

.job-card-content {
  flex: 1;
}

.arrow {
  font-size: 1.5rem;
  color: #4ec9b0;
  opacity: 0;
  transition: all 0.3s ease;
}

.job-card:hover .arrow {
  opacity: 1;
  transform: translateX(5px);
}

h2 {
  color: #4ec9b0;
  margin: 0 0 0.5rem 0;
}

.company {
  color: #9cdcfe;
  margin: 0.25rem 0;
}

.duration {
  color: #6a9955;
  font-size: 0.9rem;
  margin: 0.25rem 0;
}

.technologies {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
  flex-wrap: wrap;
}

.tech-tag {
  background-color: #1e1e1e;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  color: #ce9178;
}

.tech-tag.more {
  background-color: #333;
  color: #666;
}
</style> 